import { ajax } from '../../utils/fetch';

import { statusMsg } from '../../utils/utils';

import PopupFactory from '../body/blocks/popup/popupFactory';

const templateLandingBanner = document.createElement('template');

templateLandingBanner.innerHTML = `<main class="course-banner mh-a">
                                    <input type="file" name="cover-upload" id="cover-upload">
                                    <label for="cover-upload" class="editable"><img src="https://storage.googleapis.com/adaptiveyou/adaptiveu-v2/icons/camera-icon.svg" alt=""> Upload Image</label>
                                    <img class= "landing-banner" src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=581511fae3d6e46d55eb0b6f3d86b69d&auto=format&fit=crop&w=1350&q=80" alt="" onerror="this.src='https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=581511fae3d6e46d55eb0b6f3d86b69d&auto=format&fit=crop&w=1350&q=80'">
                                </main>`;

export default class LandingBanner extends HTMLElement {
  set semanticname(val) {
    if (val) this.setAttribute('semanticname', val);
  }

  get semanticname() {
    return this.getAttribute('semanticname');
  }

  set mode(val) {
    if (val) this.setAttribute('mode', val);
  }

  get mode() {
    return this.getAttribute('mode');
  }

  static get observedAttributes() {
    return ['semanticname', 'mode'];
  }

  connectedCallback() {
    this.appendChild(templateLandingBanner.content.cloneNode(true));
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'semanticname' && newVal)
      this._renderBanner(this._bannerImage);

    if (name === 'mode' && newVal && newVal === 'edit') this._bindImageClick();
  }

  // eslint-disable-next-line class-methods-use-this
  async _fetchBannerDetails(semanticName) {
    try {
      const request = {};
      request.contentType = 'application/json; charset=utf-8';
      request.method = 'GET';
      request.url = `/api/v1/university/${semanticName}/landing/bannerImage`;

      return await ajax(request);
    } catch (e) {
      console.error(`Error while fetching banner details :: ${e.message}`);
    }
    return {};
  }

  _renderBanner(bannerImage) {
    if (bannerImage)
      this.querySelector('.landing-banner').setAttribute('src', bannerImage);
  }

  _bindImageClick() {
    try {
      this.querySelector('#cover-upload').addEventListener(
        'change',
        async e => {
          let cropPopup = this.querySelector('au-crop');

          const pathQueryMap = {
            pathMap: this._pathMap,
            queryMap: this._queryMap,
            historyState: this._historyState
          };
          const cropPopupFactory = new PopupFactory('crop', pathQueryMap);
          if (!cropPopup) {
            cropPopup = cropPopupFactory.createComponent();
            this.appendChild(cropPopup);
          }

          cropPopup._file = e;
          cropPopup._minHeight = this.querySelector(
            '#cover-upload'
          ).parentNode.offsetHeight;
          cropPopup._minWidth = this.querySelector(
            '#cover-upload'
          ).parentNode.offsetWidth;
          cropPopup._componentName = 'au-landing-banner';

          cropPopupFactory.setAttributes(
            cropPopup,
            this.getAttribute('semanticname')
          );

          cropPopup.addEventListener('afterUpload', event => {
            this._afterUpload(event.detail.link);
          });

          cropPopup.addEventListener('statusMsg', event => {
            statusMsg(event.detail.msg, event.detail.status, this);
          });

          cropPopup.addEventListener('removeFile', () => {
            this.querySelector('.course-banner').querySelector('input').value =
              '';
          });
        }
      );
    } catch (e) {
      console.error(`Error while banner image click:: ${e.message}`);
    }
  }

  async _afterUpload(link) {
    try {
      const univDetails = {};
      univDetails.semanticName = window.univ.semanticName;
      univDetails.bannerImage = link;

      const request = {};

      request.contentType = 'application/json; charset=utf-8';

      request.method = 'PATCH';

      request.url = `/api/v1/university/${this.getAttribute(
        'semanticname'
      )}/bannerImage`;

      request.body = {};

      request.body = univDetails;

      const response = await ajax(request);

      if (response) {
        if (response.status) {
          this.querySelector('.landing-banner').setAttribute('src', link);
        } else {
          statusMsg(response.msg, 'warning');
        }
      }
    } catch (e) {
      console.error(`Error while banner image click:: ${e.message}`);
    }
  }
}
